import { useSelector } from 'react-redux'

import { userIsLoggedIn } from 'store/currentUser/selectors'

import FavoritesLoggedInContainer from './FavoritesLoggedIn.container'
import FavoritesUnloggedContainer from './FavoritesUnlogged.container'

const PassportFavoritesPage = (props) => {
  const isLoggedIn = useSelector(userIsLoggedIn)

  return isLoggedIn ? (
    <FavoritesLoggedInContainer {...props} />
  ) : (
    <FavoritesUnloggedContainer {...props} />
  )
}

export default PassportFavoritesPage
